import { Animator } from '@play-co/timestep-core/ui';
import NakedPromise from 'src/game/minigame/match2-timestep/lib/pattern/NakedPromise';

/**
 * Creates a promise from an animation. Will resolve even if the animation is interrupted.
 * Recommended most of the time over `animation.toPromise()`.
 * @param animation
 * @returns A promise that resolves to true if the animation finished, false if it was interrupted.
 */
export function toPromise(animation: Animator): Promise<boolean> {
  const promise = new NakedPromise<boolean>();

  // Keep the original clearQueue function.
  const anyAnim = animation as any;
  const originalClearQueue = anyAnim.__clearQueue ?? anyAnim._clearQueue;
  anyAnim.__clearQueue = originalClearQueue;

  // Add a resolver to the animation.
  anyAnim._resolvers = anyAnim._resolvers ?? [];
  anyAnim._resolvers.push(promise.resolve);

  // Override the clearQueue function to resolve all promises.
  anyAnim._clearQueue = function () {
    anyAnim._resolvers.forEach((resolve: (value: boolean) => void) => {
      resolve(false);
    });
    anyAnim._resolvers = [];
    originalClearQueue.call(this);
  };

  // Also resolve the promises when the animation completes.
  animation.toPromise().then(() => {
    anyAnim._resolvers.forEach((resolve: (value: boolean) => void) => {
      resolve(true);
    });
    anyAnim._resolvers = [];
  });

  return promise;
}
